import moment from 'moment'
import { DELAY_BEFORE_AVAILABLE_DAYS } from 'pages/my-calendars/constants'
import { LocationCalendars, WeekDay } from '../interfaces'

export const validateCalendar = (calendar: LocationCalendars[]) => {
    const isSomeLastOrderDateEmpty = calendar.some(
        (item) => !item.lastOrderDate && item.firstOrderDate
    )
    const isSomeFirstOrderDateEmpty = calendar.some(
        (item) => item.lastOrderDate && !item.firstOrderDate
    )
    const isSomeDeliveryDateEmpty = calendar.some((item) => {
        const unavailableWeekdays = item.storedeliveryUnavailableWeekDays?.map((i) => i.weekDay)
        const weekdays = [
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday',
            'Sunday'
        ]
        const checkIsEmpty = (item: Pick<LocationCalendars, 'deliveryDate' | 'orderDate'>) => {
            if (item.deliveryDate && !item.orderDate) return true

            const orderDateIndex = moment(item.orderDate).weekday()
            if (unavailableWeekdays?.includes(weekdays[orderDateIndex] as WeekDay)) {
                return true
            }

            return false
        }

        if (item.lastOrderDate && item.firstOrderDate && checkIsEmpty(item)) {
            return true
        }

        for (const additionalField of item.additionalFields) {
            if (checkIsEmpty(additionalField)) return true
        }
    })

    const isOrderDatesIsEmpty = calendar.some((item) => {
        const isFirstDatesEmpty = !item.firstOrderDate || !item.lastOrderDate

        if ((item.deliveryDate || item.orderDate) && isFirstDatesEmpty) return true

        for (const { deliveryDate, orderDate } of item.additionalFields) {
            if ((deliveryDate || orderDate) && isFirstDatesEmpty) return true
        }

        if (
            item.lastOrderDate &&
            moment(item.lastOrderDate) < moment().add(DELAY_BEFORE_AVAILABLE_DAYS, 'days')
        )
            return true

        return false
    })

    const isAllDateEmpty = calendar.every((item) => !item.lastOrderDate && !item.firstOrderDate)

    const errorTypes: Record<string, boolean> = {
        isSomeLastOrderDateEmpty,
        isSomeFirstOrderDateEmpty,
        isSomeDeliveryDateEmpty,
        isOrderDatesIsEmpty,
        isAllDateEmpty
    }

    const errorType = Object.keys(errorTypes).find((key) => errorTypes[key]) || 'None'

    return {
        errorType,
        isError: Object.values(errorTypes).some((item) => item)
    }
}
